import { useEffect, useMemo, useState } from "react";
import "./styles/index.less";
import {
  Col,
  Row,
  Table,
  Card,
  Select,
  Avatar,
  Typography,
  Tooltip,
  Breadcrumb,
  Grid,
} from "antd";
import "moment/locale/th";
import RankImage from "../../assets/iconshare/medal.png";
import RankImage1 from "../../assets/iconshare/medal1.png";
import RankImage2 from "../../assets/iconshare/medal2.png";
import { Content } from "antd/es/layout/layout";
import { useNavigate, useParams } from "react-router-dom";
import { get_leaderboardScore } from "../../services/submission";
import { get_task } from "../../services/task";
import { useAuth } from "../../utils/Auth/AuthWrapper";
import ExportExcel from "./component/exportExcel";
// image
import User1 from "../../assets/images/icons/user1.png";
import User2 from "../../assets/images/icons/user2.png";
import User3 from "../../assets/images/icons/user3.png";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { get_task_member } from "../../services/task_member";
import { get_role } from "../../services/user";
//
const { Text, Title } = Typography;
const { Meta } = Card;
const { useBreakpoint } = Grid;

type Props = {
  task_id?: string;
  activeTab: any;
};

const Leaderboard: React.FC<Props> = (props) => {
  const { task_id } = props;
  const test_modelname = {
    title: "Model Name",
    dataIndex: "docker_image",
    align: "center",
    key: "model",
    fixed: "left",
    width: 200,
    // render: (_: any, row: any) => _,
    render: (text: string) => <span style={{ fontSize: 16 }}>{text}</span>,
  };
  const t1 = true;
  const columns: any = [
    {
      title: "Rank",
      dataIndex: "rank",
      key: "rank",
      align: "center",
      fixed: "left",
      width: 100,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      // align: "center",
      fixed: "left",
      width: 200,
      render: (_: any, record: any) => {
        const isBaseline = record.name === "Baseline";
        return (
          <Tooltip title={record.name}>
            <div
              className={isBaseline ? "baseline-highlight" : ""}
              style={{ width: "100%" }}
            >
              <span className="table-displayname">{record.name}</span>
            </div>
          </Tooltip>
        );
      },
    },
    // {
    //   title: "Model Name",
    //   dataIndex: "docker_image",
    //   align: "center",
    //   key: "model",
    //   fixed: "left",
    //   width: 200,
    //   render: (_: any, row: any) => _,
    // },
  ];

  const navigate = useNavigate();
  const [metric, setMetric] = useState("accuracy");
  const params = useParams();
  const auth = useAuth();
  const { t } = useTranslation();
  const [columnDynamic, setColumnDynamic] = useState<any>(columns);
  const screens: any = useBreakpoint();
  const gridPoint = Object.keys(screens).filter((item: any) => screens[item]);
  const [columnsMain, setColumnsMain] = useState<any>(columns);
  const [dataExport, setDataExport] = useState<any>([]);
  const [dataExportTask, setDataExportTask] = useState<any>([]);

  const [defualtMetric, setDefualtMetric] = useState<any>([
    { label: "ทั้งหมด", value: "all" },
  ]);
  const [optionsMetric, setOptionsMetric] = useState<any>([
    { label: "ทั้งหมด", value: "all" },
  ]);

  const [valueType, setValueType] = useState("private");
  const [optionsType, setOptionsType] = useState<any>([
    { label: "Private", value: "private" },
    { label: "Public", value: "public" },
  ]);
  const [valueOrder, setValueOrder] = useState("asc");

  const [isLoading, setIsLoading] = useState(false);

  const [valueOptions, setValueOptions] = useState<any>("all");
  const [profile, setProfile] = useState<any>([]);
  const [scoreUser, setScoreUser] = useState<any>([]);
  const [scoreNotTop3, setScoreNotTop3] = useState<any>([]);
  const [defaultMetric, setDefaultMetric] = useState<any>({});
  const [checkmodel, setCheckmodel] = useState();

  // Use task_id from props if available, otherwise use params.task_id
  const currentTaskId = task_id || params.task_id;

  const getData = async () => {
    try {
      const data = {
        task_id: currentTaskId,
      };
      const res = await get_task(data);
      getMember(res.result[0]);

      setCheckmodel(res.result[0].submission_type);

      if (res.result[0].metrics) {
        if (res.result[0].submission_type == 1) {
          // columns.push(test_modelname);
          // columnDynamic.push(test_modelname);
        }
        const newColumn = JSON.parse(res.result[0].metrics).map((item: any) => {
          return {
            title: item.description,
            dataIndex: item.name,
            key: item.name,
            checktype: true,
            align: "center",
            width: 150,
          };
        });
        const filterDefault: any = JSON.parse(res.result[0].metrics).filter(
          (item: any) => item.default,
        );
        setProfile(res.result[0]);
        const optionMetric = [
          ...defualtMetric,
          ...filterDefault?.map((item: any) => {
            setValueOptions(item.name);
            return {
              label: item.description,
              value: item.name,
            };
          }),
        ];
        setOptionsMetric(optionMetric);
        setColumnDynamic([...columns, ...newColumn]);
        // setColumnDynamic([...columnDynamic, ...newColumn]);
        setColumnsMain([
          ...columns,
          ...filterDefault?.map((item: any) => {
            return {
              title: item.description,
              dataIndex: item.name,
              key: item.name,
              checktype: true,
              align: "center",
              width: 150,
            };
          }),
        ]);
        setDataExportTask(res.result);
        setDefaultMetric(filterDefault[0]);
        getScoreUser(filterDefault[0], null, res.result[0]);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getMember = async (detail: any) => {
    try {
      setIsLoading(true);
      const res_member = await get_task_member({
        task_id: currentTaskId,
      });
      const checkMember = res_member.data.filter((item: any) => {
        if (item.user_id == auth.user.user_id) {
          return true;
        }
      });

      let role = "User";
      if (auth.user.role != "User") {
        const role_user = await get_role();
        role = role_user.result[0].role_name;
      }
      // ====================
      const isSuperAdmin = role === "Super Admin";
      const isNotMemberOrBasicRole =
        checkMember.length === 0 || checkMember[0].role === 1;

      if (detail.status === 0) {
        if (!isSuperAdmin && isNotMemberOrBasicRole) {
          navigate("/");
        }
      } else {
        const all_date = JSON.parse(detail.event_date);

        const checkDataDate = all_date ? all_date : [];

        const resultDate = checkDataDate[0]?.result_date
          ? checkDataDate[0]?.result_date
          : detail.result_date;
        const isBeforeResultDate =
          resultDate === null || dayjs().isBefore(dayjs(resultDate));

        if (isBeforeResultDate && !isSuperAdmin && isNotMemberOrBasicRole) {
          setOptionsType([{ label: "Public", value: "public" }]);
          setValueType("public");
        }
      }
      setIsLoading(false);
    } catch (e) {
      console.error(e);
    }
  };

  const getScoreUser = async (mainMetric: any, type?: any, dataTask?: any) => {
    try {
      let typeLeaderboard = type;

      if (dataTask) {
        const all_date = dataTask?.event_date
          ? JSON.parse(dataTask?.event_date)
          : [];
        const resultDate = all_date[0]?.result_date || dataTask.result_date;
        const isBeforeResultDate =
          !resultDate || dayjs().isBefore(dayjs(resultDate));

        let isSuperAdmin = auth.user.role === "Super Admin";
        if (!isSuperAdmin && auth.user.role !== "User") {
          const role_user = await get_role();
          isSuperAdmin = role_user.result[0]?.role_name === "Super Admin";
        }

        const res_member = await get_task_member({ task_id: currentTaskId });
        const memberInfo = res_member.data.find(
          (item: any) => item.user_id == auth.user.user_id,
        );
        const isTaskAdmin = memberInfo && memberInfo.role !== 1;

        const hasPrivilege = isSuperAdmin || isTaskAdmin;

        if (hasPrivilege) {
          typeLeaderboard = "private";
        } else {
          typeLeaderboard = isBeforeResultDate ? "public" : "private";
        }
      }

      const data = {
        task_id: currentTaskId,
        name: mainMetric?.name,
        order: mainMetric?.order,
        type: typeLeaderboard,
      };
      const data_result = await get_leaderboardScore(data);
      if (data_result.status == "success") {
        setValueOrder(mainMetric?.order);
        setScoreUser(data_result.data);
        // setScoreNotTop3(data_result.data.slice(3));
      }
    } catch (e) {
      console.error(e);
    }
  };

  const toFixedNumber = (value: any) => {
    try {
      return value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
    } catch (e) {
      console.error(e);
    }
  };

  const dynamicColumns = useMemo(() => {
    const result = columnDynamic.map((item: any) => {
      if (item.checktype) {
        return {
          ...item,
          sorter: (a: any, b: any) => {
            return (
              a?.[valueType]?.[item.dataIndex] -
              b?.[valueType]?.[item.dataIndex]
            );
          },
          render: (_: any, row: any) => {
            return (
              <Tooltip
                title={
                  valueType == "public"
                    ? row.public?.[item.dataIndex] != undefined
                      ? row.public?.[item.dataIndex]
                      : "-"
                    : row.private?.[item.dataIndex] != undefined
                      ? row.private?.[item.dataIndex]
                      : "-"
                }
              >
                {valueType == "public"
                  ? row.public?.[item.dataIndex] != undefined
                    ? toFixedNumber(row.public?.[item.dataIndex])
                    : "-"
                  : row.private?.[item.dataIndex] != undefined
                    ? toFixedNumber(row.private?.[item.dataIndex])
                    : "-"}
              </Tooltip>
            );
          },
        };
      }
      return item;
    });
    return result;
  }, [columnDynamic, valueType, metric]);

  const mainColumns = useMemo(() => {
    const result = columnsMain.map((item: any) => {
      if (item.checktype) {
        return {
          ...item,
          render: (_: any, row: any) => {
            return (
              <Tooltip
                title={
                  valueType == "public"
                    ? row.public?.[item.dataIndex] != undefined
                      ? row.public?.[item.dataIndex]
                      : "-"
                    : row.private?.[item.dataIndex] != undefined
                      ? row.private?.[item.dataIndex]
                      : "-"
                }
              >
                {valueType == "public"
                  ? row.public?.[item.dataIndex] != undefined
                    ? toFixedNumber(row.public?.[item.dataIndex])
                    : "-"
                  : row.private?.[item.dataIndex] != undefined
                    ? toFixedNumber(row.private?.[item.dataIndex])
                    : "-"}
              </Tooltip>
            );
          },
        };
      }
      return item;
    });
    return result;
    // return columnsMain;
  }, [columnsMain, valueType, metric]);

  const dynamicMenu = useMemo(() => {
    return optionsMetric;
  }, [optionsMetric]);

  const name = useMemo(() => {
    return valueOptions;
  }, [valueOptions]);

  const userList: any = useMemo(() => {
    if (metric == "all") {
      return scoreUser;
    } else {
      const newResult = scoreUser.filter((item: any) => {
        if (valueType == "public") {
          return item.default_public != null;
        } else if (valueType == "private") {
          return item.default_private != null;
        }
      });
      // const sortedData = newResult.sort((a: any, b: any) => {
      //   if (valueOrder === "asc") {
      //     if (valueType == "public") {
      //       return a.default_public - b.default_public;
      //     } else if (valueType == "private") {
      //       return a.default_private - b.default_private;
      //     }
      //   }
      //   if (valueType == "public") {
      //     return b.default_public - a.default_public;
      //   } else if (valueType == "private") {
      //     return b.default_private - a.default_private;
      //   }
      // });
      // console.log("sortedData", sortedData);
      // setScoreNotTop3(sortedData.slice(3));
      // return sortedData;
      setScoreNotTop3(newResult.slice(3));
      return newResult;
    }
  }, [scoreUser, valueType, metric]);

  const truncateTitle = (title: any, maxLength: any) => {
    if (title?.length > maxLength) {
      return title.substring(0, maxLength) + "...";
    }
    return title;
  };

  useEffect(() => {}, [checkmodel]);

  useEffect(() => {
    // if (currentTaskId) {
    if (currentTaskId || props.activeTab == "5") {
      getData();
    }
    // }, [currentTaskId]);
  }, [currentTaskId, props.activeTab]);

  return (
    <Content className="leaderboard-layout">
      {/* head */}
      {!task_id && (
        <>
          <Breadcrumb
            separator=">"
            items={[
              {
                title: (
                  <a
                    style={{ fontWeight: "bold" }}
                    onClick={(e) => {
                      e.preventDefault(); // ป้องกันรีเฟรช
                      navigate("/task");
                    }}
                  >
                    {t("Task")}
                  </a>
                ),
              },
              {
                title: (
                  <a
                    style={{ fontWeight: "bold" }}
                    onClick={(e) => {
                      e.preventDefault(); // ป้องกันรีเฟรช
                      navigate("/task/detail/" + currentTaskId);
                    }}
                  >
                    {truncateTitle(profile?.name, 20)}
                  </a>
                ),
              },
              {
                title: (
                  <>
                    <span style={{ fontWeight: "bold" }}>
                      {t("Leaderboard")}
                    </span>
                  </>
                ),
              },
            ]}
          />
          <hr />
        </>
      )}

      {/* sort table */}
      <div
        style={{
          margin: "20px 0px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Row align="middle" justify="end" gutter={[8, 8]}>
          {auth.user.role == "User" ? (
            <></>
          ) : (
            <>
              <Col flex={"auto"}>
                <Row justify={"end"} align={"middle"}>
                  <Col>
                    <Text>Type :&nbsp;&nbsp;&nbsp;&nbsp;</Text>
                  </Col>
                  <Col style={{ marginRight: "10px" }}>
                    <Select
                      value={valueType}
                      style={{ width: "200px" }}
                      onChange={(value) => {
                        // setValueOptions(value);
                        getScoreUser(defaultMetric, value);
                        setValueType(value);
                      }}
                      options={optionsType}
                    ></Select>
                  </Col>
                </Row>
              </Col>
            </>
          )}
          <Col flex={"auto"}>
            <Row justify={"end"} align={"middle"}>
              <Col>
                <Text>Metric :&nbsp;&nbsp;&nbsp;&nbsp;</Text>
              </Col>
              <Col style={{ marginRight: "10px" }}>
                <Select
                  value={name}
                  style={{ width: "200px" }}
                  onChange={(value) => {
                    setValueOptions(value);
                    setMetric(value);
                  }}
                  options={dynamicMenu}
                ></Select>
              </Col>
            </Row>
          </Col>

          {auth.user.role == "User" || auth.user.role == "Member" ? null : (
            <Col flex={"auto"}>
              <Row justify={"end"} align={"middle"}>
                <Col offset={2}>
                  <ExportExcel
                    dataExport={dataExport}
                    dataExportTask={dataExportTask}
                  />
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      </div>

      {metric === "all" ? (
        <>
          <Table
            className="custom-leaderboard-table"
            columns={dynamicColumns}
            rowKey={"id"}
            scroll={{ x: 500 }}
            dataSource={userList.map((item: any, ind: number) => {
              return {
                ...item,
                rank: ind + 1,
              };
            })}
            pagination={false}
            style={{ textAlign: "center", marginTop: 20 }}
            rowClassName={(record: any) =>
              record.name === "Baseline" ? "baseline-highlight" : ""
            }
          />
        </>
      ) : (
        <>
          {gridPoint.includes("xs") ? (
            <Row
              gutter={[16, 16]}
              justify="space-around"
              style={{ marginBottom: "1.5rem" }}
            >
              <Col xs={24}>
                <Row justify={"center"}>
                  <img
                    src={RankImage}
                    style={{ width: "60px", height: "60px", marginBottom: 15 }}
                    alt="Rank 2"
                  />
                </Row>
                <Row>
                  <Card
                    className="leaderboard-card-small"
                    style={{ width: "100%" }}
                  >
                    <Meta
                      avatar={<Avatar size={64} src={User1} />}
                      title={
                        <h2 className="card-title">
                          {userList[0]?.name ? userList[0]?.name : "-"}
                        </h2>
                      }
                      // description={
                      //   checkmodel === 2 ? null : (
                      //     <p className="card-model">
                      //       Model: {userList[0]?.docker_image}
                      //     </p>
                      //   )
                      // }
                    />
                    <div className="card-score">
                      <p className="points-label">
                        {userList[0] ? name : "No data"}
                      </p>
                      <span className="score">
                        {" "}
                        <Tooltip
                          title={
                            valueType == "public"
                              ? userList[0]?.default_public != undefined
                                ? userList[0]?.default_public
                                : "-"
                              : userList[0]?.default_private != undefined
                                ? userList[0]?.default_private
                                : "-"
                          }
                        >
                          {valueType == "public"
                            ? userList[0]?.default_public != undefined
                              ? toFixedNumber(userList[0]?.default_public)
                              : "-"
                            : userList[0]?.default_private != undefined
                              ? toFixedNumber(userList[0]?.default_private)
                              : "-"}
                        </Tooltip>
                      </span>
                    </div>
                  </Card>
                </Row>
              </Col>

              {/* อันดับ 2 */}
              <Col xs={24}>
                <Row justify={"center"}>
                  <img
                    src={RankImage1}
                    style={{ width: "60px", height: "60px", marginBottom: 15 }}
                    alt="Rank 1"
                  />
                </Row>
                <Row>
                  <Card
                    className="leaderboard-card2-small"
                    style={{ width: "100%" }}
                  >
                    <Meta
                      avatar={<Avatar size={64} src={User2} />}
                      title={
                        <h2 className="card-title ">
                          {userList[1]?.name ? userList[1]?.name : "-"}
                        </h2>
                      }
                      // description={
                      //   checkmodel === 2 ? null : (
                      //     <p className="card-model">
                      //       Model: {userList[1]?.docker_image}
                      //     </p>
                      //   )
                      // }
                    />
                    <div className="card-score2">
                      <p className="points-label">
                        {userList[1] ? name : "No data"}
                      </p>
                      <span className="score">
                        <Tooltip
                          title={
                            valueType == "public"
                              ? userList[1]?.default_public != undefined
                                ? userList[1]?.default_public
                                : "-"
                              : userList[1]?.default_private != undefined
                                ? userList[1]?.default_private
                                : "-"
                          }
                        >
                          {valueType == "public"
                            ? userList[1]?.default_public != undefined
                              ? toFixedNumber(userList[1]?.default_public)
                              : "-"
                            : userList[1]?.default_private != undefined
                              ? toFixedNumber(userList[1]?.default_private)
                              : "-"}
                        </Tooltip>
                      </span>
                    </div>
                  </Card>
                </Row>
              </Col>

              {/* อันดับ 3 */}
              <Col xs={24}>
                <Row justify={"center"}>
                  <img
                    src={RankImage2}
                    style={{ width: "60px", height: "60px", marginBottom: 15 }}
                    alt="Rank 3"
                  />
                </Row>
                <Row>
                  <Card
                    className="leaderboard-card3-small"
                    style={{ width: "100%" }}
                  >
                    <Meta
                      avatar={<Avatar size={64} src={User3} />}
                      title={
                        <h2 className="card-title">
                          {userList[2]?.name ? userList[2]?.name : "-"}
                        </h2>
                      }
                      // description={
                      //   checkmodel === 2 ? null : (
                      //     <p className="card-model">
                      //       Model: {userList[2]?.docker_image}
                      //     </p>
                      //   )
                      // }
                    />
                    <div className="card-score3">
                      <p className="points-label">
                        {userList[2] ? name : "No data"}
                      </p>
                      <span className="score">
                        {" "}
                        <Tooltip
                          title={
                            valueType == "public"
                              ? userList[2]?.default_public != undefined
                                ? userList[2]?.default_public
                                : "-"
                              : userList[2]?.default_private != undefined
                                ? userList[2]?.default_private
                                : "-"
                          }
                        >
                          {valueType == "public"
                            ? userList[2]?.default_public != undefined
                              ? toFixedNumber(userList[2]?.default_public)
                              : "-"
                            : userList[2]?.default_private != undefined
                              ? toFixedNumber(userList[2]?.default_private)
                              : "-"}
                        </Tooltip>
                      </span>
                    </div>
                  </Card>
                </Row>
              </Col>
            </Row>
          ) : (
            <Row justify={"center"} align={"bottom"}>
              {/* อันดับ 2 */}
              <Col xs={8} lg={8} xl={6}>
                <Row justify={"center"}>
                  <img
                    src={RankImage1}
                    style={{ width: "60px", height: "60px", marginBottom: 15 }}
                    alt="Rank 1"
                  />
                </Row>
                <Row>
                  <Card className="leaderboard-card2" style={{ width: "100%" }}>
                    <Meta
                      avatar={<Avatar size={64} src={User2} />}
                      title={
                        <Tooltip
                          title={userList[1]?.name ? userList[1]?.name : "-"}
                        >
                          <div style={{ width: "250px" }}>
                            <span className="card-title table-displayname">
                              {userList[1]?.name ? userList[1]?.name : "-"}
                            </span>
                          </div>
                        </Tooltip>
                      }
                      // description={
                      //   checkmodel === 2 ? null : (
                      //     <p className="card-model">
                      //       Model: {userList[1]?.docker_image}
                      //     </p>
                      //   )
                      // }
                    />
                    <div className="card-score2">
                      <p className="points-label">
                        {userList[1] ? name : "No data"}
                      </p>
                      <span className="score">
                        <Tooltip
                          title={
                            valueType == "public"
                              ? userList[1]?.default_public != undefined
                                ? userList[1]?.default_public
                                : "-"
                              : userList[1]?.default_private != undefined
                                ? userList[1]?.default_private
                                : "-"
                          }
                        >
                          {valueType == "public"
                            ? userList[1]?.default_public != undefined
                              ? toFixedNumber(userList[1]?.default_public)
                              : "-"
                            : userList[1]?.default_private != undefined
                              ? toFixedNumber(userList[1]?.default_private)
                              : "-"}
                        </Tooltip>
                      </span>
                    </div>
                  </Card>
                </Row>
              </Col>

              {/* อันดับ 1 */}
              <Col xs={8} lg={8} xl={6}>
                <Row justify={"center"}>
                  <img
                    src={RankImage}
                    style={{ width: "60px", height: "60px", marginBottom: 15 }}
                    alt="Rank 2"
                  />
                </Row>
                <Row>
                  <Card className="leaderboard-card" style={{ width: "100%" }}>
                    <Meta
                      avatar={<Avatar size={64} src={User1} />}
                      title={
                        <Tooltip
                          title={userList[0]?.name ? userList[0]?.name : "-"}
                        >
                          <div style={{ width: "250px" }}>
                            <span className="card-title table-displayname">
                              {userList[0]?.name ? userList[0]?.name : "-"}
                            </span>
                          </div>
                        </Tooltip>
                      }
                      // description={
                      //   checkmodel === 2 ? null : (
                      //     <p className="card-model">
                      //       Model: {userList[0]?.docker_image}
                      //     </p>
                      //   )
                      // }
                    />
                    <div className="card-score">
                      <p className="points-label">
                        {userList[0] ? name : "No data"}
                      </p>
                      <span className="score">
                        {" "}
                        <Tooltip
                          title={
                            valueType == "public"
                              ? userList[0]?.default_public != undefined
                                ? userList[0]?.default_public
                                : "-"
                              : userList[0]?.default_private != undefined
                                ? userList[0]?.default_private
                                : "-"
                          }
                        >
                          {valueType == "public"
                            ? userList[0]?.default_public != undefined
                              ? toFixedNumber(userList[0]?.default_public)
                              : "-"
                            : userList[0]?.default_private != undefined
                              ? toFixedNumber(userList[0]?.default_private)
                              : "-"}
                        </Tooltip>
                      </span>
                    </div>
                  </Card>
                </Row>
              </Col>

              {/* อันดับ 3 */}
              <Col xs={8} lg={8} xl={6}>
                <Row justify={"center"}>
                  <img
                    src={RankImage2}
                    style={{ width: "60px", height: "60px", marginBottom: 15 }}
                    alt="Rank 3"
                  />
                </Row>
                <Row>
                  <Card className="leaderboard-card3" style={{ width: "100%" }}>
                    <Meta
                      avatar={<Avatar size={64} src={User3} />}
                      title={
                        <Tooltip
                          title={userList[2]?.name ? userList[2]?.name : "-"}
                        >
                          <div style={{ width: "250px" }}>
                            <span className="card-title table-displayname">
                              {userList[2]?.name ? userList[2]?.name : "-"}
                            </span>
                          </div>
                        </Tooltip>
                      }
                      // description={
                      //   checkmodel === 2 ? null : (
                      //     <p className="card-model">
                      //       Model: {userList[2]?.docker_image}
                      //     </p>
                      //   )
                      // }
                    />
                    <div className="card-score3">
                      <p className="points-label">
                        {userList[2] ? name : "No data"}
                      </p>
                      <span className="score">
                        {" "}
                        <Tooltip
                          title={
                            valueType == "public"
                              ? userList[2]?.default_public != undefined
                                ? userList[2]?.default_public
                                : "-"
                              : userList[2]?.default_private != undefined
                                ? userList[2]?.default_private
                                : "-"
                          }
                        >
                          {valueType == "public"
                            ? userList[2]?.default_public != undefined
                              ? toFixedNumber(userList[2]?.default_public)
                              : "-"
                            : userList[2]?.default_private != undefined
                              ? toFixedNumber(userList[2]?.default_private)
                              : "-"}
                        </Tooltip>
                      </span>
                    </div>
                  </Card>
                </Row>
              </Col>
            </Row>
          )}
          {scoreNotTop3.length != 0 ? (
            <Table
              className="custom-leaderboard-table"
              columns={mainColumns}
              rowKey={"id"}
              scroll={{ y: 400 }}
              dataSource={scoreNotTop3.map((item: any, ind: number) => ({
                ...item,
                rank: ind + 4,
                key: ind + 4,
              }))}
              pagination={false}
              style={{ marginTop: "20px" }}
              rowClassName={(record: any) =>
                record.name === "Baseline" ? "baseline-highlight" : ""
              }
            />
          ) : null}
        </>
      )}
    </Content>
    // </div>
  );
};

export default Leaderboard;
